export default __webpack_public_path__ + "static/media/plain-sticker-c.615f488e.png";